export enum ForexTypes {
  API_SUCCESS = "@@forex_data/API_SUCCESS",
  API_ERROR = "@@forex_data/API_ERROR",
  GET_FOREX_DATA = "@@forex_data/GET_FOREX_DATA",
  GET_COMMISIONS = "@@forex_data/GET_COMMISIONS",
  GET_SETTLEMENTS = "@@forex_data/GET_SETTLEMENTS",
}
